import Vue from 'vue';
import router from '../../../ugsrc/router/index';
import { EventBus } from '../../../common/assets/utils/eventBus';

export const usersDetails = {
    namespaced: true,
    state: {
        allUsers: []
    },
    getters: {
      
    },
    actions: {
        getAllUsersData({state, commit, dispatch}, data) {
            EventBus.$emit('showLoadingIcon', true);
            Vue.http.get('/users/')
			.then((res) => {
                commit('saveAllUsersData', res.data);
                EventBus.$emit('showLoadingIcon', false);
			}, (error) => {
                EventBus.$emit('showLoadingIcon', false);
                console.log("Something went Wrong: ", error);
			})
        },
        resetAllUsersData({commit}, data){
            commit('saveAllUsersData', []);
        }
    },
    mutations: {
      saveAllUsersData(state, usersData){
        try{
            let newData = [];
            let users = [];
            for(var user in usersData){
                if(usersData.hasOwnProperty(user)){
                    let z = [];
                    let dummy_data = usersData[user]['fields'];
                    dummy_data['apps_information'] = usersData[user]['apps_information'];
                    dummy_data['docs_information'] = usersData[user]['docs_information'];
                    dummy_data['current_schema'] = usersData[user]['tenant_information'];
                    dummy_data['pk'] = usersData[user]['pk'];
                    dummy_data['2fa_enabled'] = usersData[user]['2fa_enabled'];
                    dummy_data['showConfirmation'] = false;
                    var x = usersData[user]['apps_information'];
                    for(var i in x){
                        if(x.hasOwnProperty(i)){
                            z.push(x[i]['ug_role']);
                        }
                    }
                    dummy_data['user_role'] = z.includes('tenantAdmin') ? true :false;
                    newData.push(dummy_data); 
                }
            }
            users = newData;
            users.sort(function(a,b){
                if(a.username<b.username) return -1;
                if(a.username>b.username) return 1;
                return 0;
            });
            state.allUsers = users;
        }
        catch(err){
            console.log("error is:",err);
            state.allUsers = [];
        }
      }
    },
  };
  